'use client'

import { usePathname } from 'next/navigation'
import { PropsWithChildren } from 'shared/types/PropsWithChildren'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

const greyRoutes: { path: string; bg: 'grey-bg' | 'white'; exact?: boolean }[] =
  [
    { path: RouterPath.HOME, bg: 'grey-bg' },
    { path: RouterPath.AUTH, bg: 'grey-bg' },
    { path: RouterPath.BUSINESS_MARKET, bg: 'grey-bg' },
    { path: RouterPath.CART, bg: 'grey-bg' },
    { path: RouterPath.FAVORITES, bg: 'grey-bg' },
    { path: RouterPath.DELIVERY, bg: 'grey-bg' },
    { path: RouterPath.HELP, bg: 'grey-bg' },
    { path: RouterPath.PRODUCT, bg: 'grey-bg' },
    { path: RouterPath.SHOP, bg: 'grey-bg' },
    { path: RouterPath.CATALOG_SHOP, bg: 'grey-bg' },
  ]

export function BackgroundLayout({ children }: PropsWithChildren) {
  const pathName = usePathname()

  const matchedRoute = greyRoutes.find(({ path, exact }) => {
    return exact
      ? pathName === path
      : pathName === path || pathName.startsWith(path + '/')
  })

  const backgroundClass = matchedRoute?.bg ?? 'white'
  return <div className={backgroundClass}>{children}</div>
}
